<script setup lang="ts">
import type { WithClassAsProps } from './interface'
import { Button } from '@layers/ui/app/components/ui/button'
import { ArrowLeft } from 'lucide-vue-next'
import { useCarousel } from './useCarousel'

const props = defineProps<WithClassAsProps>()
const appConfig = useAppConfig()
const { orientation, canScrollPrev, scrollPrev } = useCarousel()
</script>

<template>
  <Button
    :disabled="!canScrollPrev"
    :class="cn(appConfig.ui.carousel.slots.prev,
               orientation === 'horizontal'
                 ? appConfig.ui.carousel.variants.orientation.horizontal.prev
                 : appConfig.ui.carousel.variants.orientation.vertical.prev,
               props.class,
    )"
    variant="outline"
    @click="scrollPrev"
  >
    <slot>
      <ArrowLeft class="h-4 w-4 text-current" />
      <span class="sr-only">Previous Slide</span>
    </slot>
  </Button>
</template>
